<template>
    <div>
        <PageSpinner :onloader="onloader" />
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <router-link to="/dashboard" class="text-white"> Dashboard</router-link>
            <router-link to="/admin/eduschool/class-note-setup" class="text-white"> <i
                    class="fa fa-ellipsis-v px-2"></i>Class Note Setup</router-link>
            <router-link to="/admin/eduschool/class-note-lesson-setup" class="text-white"> <i
                    class="fa fa-ellipsis-v px-2"></i>Class Note Lesson Setup</router-link>
            <span class="text-white"><i class="fa fa-ellipsis-v px-2"></i>Class Note Lesson Question Setup</span>
        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--7">
            <div class="mb-5 mb-xl-0">
                <card header-classes="bg-transparent">
                    <div class="card">
                        <div class="card-body">
                            <modal :show.sync="modals.noteModal" modal-classes="modal-dialog-centered modal-lg">
                                <div class="card bg-secondary border-0 mb-0">
                                    <div class="card-body">
                                        <PageSpinner :onloader="onloader" />
                                        <form role="form">
                                            <div class="form-group">
                                                <label>Question</label>
                                                <vue-editor id="Questionval" v-model="Questionval">

                                                </vue-editor>

                                            </div>

                                            <div class="row">
                                                <div class="col-md-8">
                                                    <div class="form-group">
                                                        <label>Option A</label>
                                                        <vue-editor id="OptionAval" v-model="OptionAval">

                                                        </vue-editor>

                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <base-checkbox class="mt-6 mb-4 ml-4" v-model="IsOptionAAnswerval"
                                                        @change="checkcheck()">
                                                        Is A Answer
                                                    </base-checkbox>
                                                </div>
                                                <div class="col-md-8">
                                                    <div class="form-group">
                                                        <label>Option B</label>
                                                        <vue-editor id="OptionBval" v-model="OptionBval">

                                                        </vue-editor>

                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <base-checkbox class="mt-6 mb-6 ml-4" v-model="IsOptionBAnswerval"
                                                        @change="checkcheck()">
                                                        Is B Answer
                                                    </base-checkbox>
                                                </div>
                                                <div class="col-md-8">
                                                    <div class="form-group">
                                                        <label>Option C</label>
                                                        <vue-editor id="OptionCval" v-model="OptionCval">

                                                        </vue-editor>

                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <base-checkbox class="mt-6 mb-6 ml-4" v-model="IsOptionCAnswerval"
                                                        @change="checkcheck()">
                                                        Is C Answer
                                                    </base-checkbox>
                                                </div>
                                                <div class="col-md-8">
                                                    <div class="form-group">
                                                        <label>Option D</label>
                                                        <vue-editor id="OptionDval" v-model="OptionDval">

                                                        </vue-editor>

                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <base-checkbox class="mt-6 mb-6 ml-4" v-model="IsOptionDAnswerval"
                                                        @change="checkcheck()">
                                                        Is D Answer
                                                    </base-checkbox>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label>Answer Details</label>
                                                <vue-editor id="AnswerDetailsval" v-model="AnswerDetailsval">

                                                </vue-editor>

                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <template slot="footer">

                                    <base-button type="default" @click="modals.noteModal = false">Cancel
                                    </base-button>
                                    <base-button type="success" @click.prevent="SubmitClassNoteLessonQuestion()">Submit
                                    </base-button>
                                </template>
                            </modal>

                            <div>
                                <div class="form-inline">
                                    <div class="row" v-if="ClassNoteLessonItems">
                                        <div class="col-lg-12" v-html="ClassNoteLessonItems.classNoteLessonTitle">
                                        </div>
                                    </div>
                                </div>

                                <div class="justify-content-end form-inline">
                                    <button class="btn btn-success mr-3" v-on:click="OpenNewnoteModal()">
                                        <i class="fa fa-edit"></i> New
                                    </button>
                                    <base-input class="input-group-alternative" placeholder="Search here..."
                                        addon-left-icon="fa fa-search" v-model="searchValueval">
                                    </base-input>
                                </div>
                                <list-skeleton v-if="!ClassNoteLessonQuestionItems" :rows="3" />
                                <div v-else>
                                    <div class="card bg-secondary my-2"
                                        v-for="(item, index) in ClassNoteLessonQuestionItems"
                                        :key="item.classNoteLessonQuestionId">
                                        <div class="card-body">
                                            <span class="badge badge-warning">
                                                Qtn. {{ index + 1 }}</span>
                                            <div class="my-3" v-html="item.question"></div>
                                            <div class="m-3">
                                                <div class="row">
                                                    <div class="col-lg-1">
                                                        <span v-if="item.isOptionAAnswer"
                                                            class="badge badge-success">A</span>
                                                        <span v-else class="badge badge-dark">A</span>
                                                    </div>

                                                    <div class="col-lg-11" v-html="item.optionA"></div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-lg-1">
                                                        <span v-if="item.isOptionBAnswer"
                                                            class="badge badge-success">B</span>
                                                        <span v-else class="badge badge-dark">B</span>
                                                    </div>
                                                    <div class="col-lg-11" v-html="item.optionB"></div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-lg-1">
                                                        <span v-if="item.isOptionCAnswer"
                                                            class="badge badge-success">C</span>
                                                        <span v-else class="badge badge-dark">C</span>
                                                    </div>
                                                    <div class="col-lg-11" v-html="item.optionC"></div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-lg-1">
                                                        <span v-if="item.isOptionDAnswer"
                                                            class="badge badge-success">D</span>
                                                        <span v-else class="badge badge-dark">D</span>
                                                    </div>
                                                    <div class="col-lg-11" v-html="item.optionD"></div>
                                                </div>
                                                <div class="bg-translucent-secondary m-3 p-3">
                                                    <b class="text-success">Answer Details</b>
                                                    <div v-html="item.answerDetails"></div>
                                                </div>
                                            </div>
                                            <div class="card-footer text-center">
                                                <button class="btn btn-secondary btn-sm my-2"
                                                    v-on:click="GetById(item)">
                                                    <i class="fa fa-edit"></i> Edit
                                                </button>
                                                <!-- <button class="btn btn-secondary btn-sm my-2"
                                                    v-on:click="deleteschquestion(item.classNoteLessonQuestionId)">
                                                    <i class="fa fa-times"></i> Delete
                                                </button> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </card>
            </div>

            <!-- End charts-->
        </div>
    </div>
</template>

<script>
import 'quill/dist/quill.snow.css'
import { VueEditor } from 'vue2-quill-editor'
import PageSpinner from "@/components/PageSpinner";
import ValidateAccessToken from "@/mixins/ValidateAccessToken.mixins";
import Alert from "@/mixins/Alert.mixins"
import katex from 'katex';
import 'katex/dist/katex.min.css';

// import modal from '@/components/Modal'
window.katex = katex;
export default {
    name: "EduSchool-Question-Setup",
    mixins: [ValidateAccessToken, Alert],
    components: {
        PageSpinner,
        VueEditor,
    },
    data() {
        return {
            accessDetails: null,
            ClassNoteLessonIdval: localStorage.getItem("ClassNoteLessonId") || "",
            ClassNoteLessonQuestionIdval: 0,
            Questionval: "",
            AnswerDetailsval: "",
            OptionAIdval: 0,
            OptionAval: "",
            IsOptionAAnswerval: false,
            OptionBIdval: 0,
            OptionBval: "",
            IsOptionBAnswerval: false,
            OptionCIdval: 0,
            OptionCval: "",
            IsOptionCAnswerval: false,
            OptionDIdval: 0,
            OptionDval: "",
            IsOptionDAnswerval: false,
            searchValueval: "All",
            ClassNoteLessonQuestionItems: null,
            ClassNoteLessonItems: null,
            isModified: false,
            onloader: "none",
            editorOption: {
                debug: 'info',
                placeholder: 'Type in here',
                readonlly: true,
                theme: 'snow'
            },
            modals: {
                noteModal: false
            }
        };
    },
    methods: {
        OpenNewnoteModal() {
            this.isModified = false;
            this.modals.noteModal = true
        },
        resetInput() {
            this.Questionval = "";
            this.AnswerDetailsval = "";
            this.OptionAIdval = 0;
            this.OptionAval = "";
            this.IsOptionAAnswerval = false;
            this.OptionBIdval = 0;
            this.OptionBval = "";
            this.IsOptionBAnswerval = false;
            this.OptionCIdval = 0;
            this.OptionCval = "";
            this.IsOptionCAnswerval = false;
            this.OptionDIdval = 0;
            this.OptionDval = "";
            this.IsOptionDAnswerval = false;
        },
        checkcheck() {
            if (this.IsOptionAAnswerval == true) {
                this.IsOptionBAnswerval = false;
                this.IsOptionCAnswerval = false;
                this.IsOptionDAnswerval = false;
            }
            if (this.IsOptionBAnswerval == true) {
                this.IsOptionAAnswerval = false;
                this.IsOptionCAnswerval = false;
                this.IsOptionDAnswerval = false;
            }
            if (this.IsOptionCAnswerval == true) {
                this.IsOptionBAnswerval = false;
                this.IsOptionAAnswerval = false;
                this.IsOptionDAnswerval = false;
            }
            if (this.IsOptionDAnswerval == true) {
                this.IsOptionBAnswerval = false;
                this.IsOptionCAnswerval = false;
                this.IsOptionAAnswerval = false;
            }
        },
        GetById(item) {
            this.resetInput();
            this.isModified = true;
            this.ClassNoteLessonQuestionIdval = item.classNoteLessonQuestionId;
            this.Questionval = item.question;
            this.AnswerDetailsval = item.answerDetails;
            this.OptionAIdval = item.optionAId;
            this.OptionAval = item.optionA;
            this.IsOptionAAnswerval = item.isOptionAAnswer;
            this.OptionBIdval = item.optionBId;
            this.OptionBval = item.optionB;
            this.IsOptionBAnswerval = item.isOptionBAnswer;
            this.OptionCIdval = item.optionCId;
            this.OptionCval = item.optionC;
            this.IsOptionCAnswerval = item.isOptionCAnswer;
            this.OptionDIdval = item.optionDId;
            this.OptionDval = item.optionD;
            this.IsOptionDAnswerval = item.isOptionDAnswer;
            this.modals.noteModal = true;
        },
        SubmitClassNoteLessonQuestion() {
            let ClassNoteLessonQuestionId = this.ClassNoteLessonQuestionIdval;
            let ClassNoteLessonId = this.ClassNoteLessonIdval;
            let Question = this.Questionval;
            let AnswerDetails = this.AnswerDetailsval;
            let OptionAId = this.OptionAIdval;
            let OptionA = this.OptionAval;
            let IsOptionAAnswer = this.IsOptionAAnswerval;
            let OptionBId = this.OptionBIdval;
            let OptionB = this.OptionBval;
            let IsOptionBAnswer = this.IsOptionBAnswerval;
            let OptionCId = this.OptionCIdval;
            let OptionC = this.OptionCval;
            let IsOptionCAnswer = this.IsOptionCAnswerval;
            let OptionDId = this.OptionDIdval;
            let OptionD = this.OptionDval;
            let IsOptionDAnswer = this.IsOptionDAnswerval;

            if (ClassNoteLessonId > 0) {
                let userdata = {};
                this.onloader = "flex";
                let operationVal = "";
                if (this.isModified == false) {
                    operationVal = "ClassNote/CreateClassNoteLessonQuestion";
                    userdata = {
                        ClassNoteLessonId,
                        Question,
                        AnswerDetails,
                        OptionA,
                        IsOptionAAnswer,
                        OptionB,
                        IsOptionBAnswer,
                        OptionC,
                        IsOptionCAnswer,
                        OptionD,
                        IsOptionDAnswer
                    }
                } else {
                    operationVal = "ClassNote/UpdateClassNoteLessonQuestion";
                    userdata = {
                        ClassNoteLessonQuestionId,
                        ClassNoteLessonId,
                        Question,
                        AnswerDetails,
                        OptionAId,
                        OptionA,
                        IsOptionAAnswer,
                        OptionBId,
                        OptionB,
                        IsOptionBAnswer,
                        OptionCId,
                        OptionC,
                        IsOptionCAnswer,
                        OptionDId,
                        OptionD,
                        IsOptionDAnswer
                    }
                }
                this.$store
                    .dispatch(operationVal, userdata)
                    .then((resp) => {
                        this.onloader = "none";
                        if (resp.responseCode == '00') {
                            this.GetClassNoteLessonQuestions();
                            this.resetInput();
                            this.modals.noteModal = false;
                            this.ShowAlertSuccess('Submitted successfully', '');
                        } else {
                            this.ShowAlertError(resp.responseMessage, '');
                        }

                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            } else {
                this.ShowAlertError('Select Subject', '');
            }

        },
        async GetClassNoteLessonById() {
            try {
                this.onloader = "flex";
                const Id = this.ClassNoteLessonIdval;

                // Wait for data from Vuex store
                const resp = await this.$store.dispatch("ClassNote/GetClassNoteLessonById", Id);

                // Populate data
                this.ClassNoteLessonItems = resp.data;
                this.ClassNoteLessonQuestionItems = resp.data.classNoteLessonQuestions;

                // Wait for DOM updates after reactivity changes

                await this.$nextTick();
                requestAnimationFrame(() => {
                    this.onloader = "none";
                });

            }
            catch (err) {
                this.onloader = "none";
                this.ShowAlertError(err.response?.data || err.message, '');
            }
        }
        ,
        GetClassNoteLessonQuestions() {
            let ClassNoteLessonId = this.ClassNoteLessonIdval;
            if (ClassNoteLessonId > 0) {
                this.onloader = "flex";
                const userData = {
                    ClassNoteLessonId
                }
                this.$store
                    .dispatch("ClassNote/GetClassNoteLessonQuestions", userData)
                    .then((resp) => {
                        this.ClassNoteLessonQuestionItems = resp.data;
                        this.onloader = "none";
                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            }
        },
    },
    computed: {
        searchedResultQuery() {
            if (this.searchval) {
                return this.ClassNoteLessonQuestionItems.filter((item) => {
                    return this.searchval
                        .toLowerCase()
                        .split(" ")
                        .every(
                            (v) =>
                                item.question.toLowerCase().includes(v)
                        );
                });
            } else {
                return this.ClassNoteLessonQuestionItems;
            }
        },

    },
    mounted() {
        const userDetails = this.accessDetails = this.$store.getters['auth/_user'];
        if (
            userDetails.isSuperAdmin == true ||
            userDetails.isAdmin == true ||
            userDetails.isSupportAdmin == true
        ) {
            this.GetClassNoteLessonById();
        } else {
            this.$store.dispatch("auth/Logout");
            this.$router.push("/login");
        }
    },
};
</script>

<style></style>